import { SerializedError } from "@reduxjs/toolkit";
import axios from "axios";
import applyCaseMiddleware from "axios-case-converter";

import { ArchiveCabinetInfoService } from "@/api/services/interfaces";
import { routes } from "@/api/services/routes";
import { lvtResponseArchiveCabinetInfoValidator } from "@/api/validation/archiveCabinetInfo";
import { logError } from "@/utilities/api";
import { ArchiveCabinetInfo } from "@/utilities/types/archive";


const client = applyCaseMiddleware(axios.create());

axios.defaults.withCredentials = true;

export const archiveCabinetInfoService: ArchiveCabinetInfoService = {
    async fetchArchiveCabinetInfo(archiveCabinetId: number): Promise<ArchiveCabinetInfo | Error> {
        const route = routes.getArchiveCabinetInfo(archiveCabinetId);

        try {
            const response = await client.get(route);

            if (lvtResponseArchiveCabinetInfoValidator(response.data)) {
                return response.data.data as ArchiveCabinetInfo;
            } else {
                const error: SerializedError = {
                    name: "validation",
                    message: JSON.stringify(lvtResponseArchiveCabinetInfoValidator.errors),
                };

                throw error;
            }
        } catch (error) {
            logError(route, error as Error);
            throw error;
        }
    },
};
